<template>
  <main class="main_inner flex-grow-1">
    <div class="account_area d-grid">
      <div class="account_wrap">
        <div class="account_wrap-container">
          <h5 class="account_title">
            {{ $t('Bao.transaction-wallet') }}
          </h5>
          <div class="account_wrap_sub d-flex align-items-center">
            <h6 class="mb-0">
              {{ $t('Bao.wallet_amount') }}
            </h6>
            <button class="btn btn_reflash" type="button" @click="refreshAll()">
              <i class="icon-repeat" />
            </button>
          </div>
          <ul class="account_wallet_info d-grid list-unstyled">
            <li>
              <div class="account_wallet_block d-flex align-items-center justify-content-between">
                <div class="account_wallet_inner d-grid">
                  <h4 class="account_wallet_main d-flex align-items-center mb-0">
                    <img src="@/assets/images/upload/img_wallet.svg" alt="">
                    <b>{{ $t('Bao.main_wallet') }}</b>
                  </h4>
                  <div class="account_wallet_sub d-flex align-items-center">
                    <h5 class="mb-0">
                      <b>{{ $t('Bao.wallet_balance') }}</b>
                    </h5>
                    <h6 class="mb-0">
                      <!--eslint-disable-next-line -->
                        <span v-html="$options.filters['numberFormat']($store.getters.commonGold)"></span>
                    </h6>
                  </div>
                </div>
                <button class="btn btn_oneclick text-white" type="button" :disabled="actionLoading" @click="showWithdrawalAllModal">
                  <b>{{ $t('Bao.leave_game_all') }}</b>
                  <i
                    v-show="actionLoading"
                    class="fa fa-spinner fa-pulse fa-fw"
                  />
                </button>
              </div>
            </li>
            <li>
              <div class="account_wallet_block d-flex align-items-center justify-content-between">
                <div class="account_wallet_inner d-grid">
                  <h4 class="account_wallet_main d-flex align-items-center mb-0">
                    <img src="@/assets/images/upload/img_auto.svg" alt="">
                    <b>{{ $t('Bao.auto_to_game') }}</b>
                  </h4>
                  <div class="account_wallet_sub d-flex align-items-center">
                    <h5 class="mb-0">
                      {{ $t('Bao.auto_to_game_notice') }}
                    </h5>
                  </div>
                </div>
                <input id="wallet_info" class="wallet_info_ipt d-none" type="checkbox" :checked="$store.getters.user.auto_to_game === 1" @click="updateAutoToGame">
                <label for="wallet_info" class="wallet_info_lab mb-0" />
              </div>
            </li>
          </ul>
          <h5 class="account_title">
            {{ $t('Bao.game_wallet') }}
          </h5>
          <ul v-if="providerSortAry" class="account_wallet_data d-flex flex-wrap list-unstyled mb-0">
            <li v-for="(item, key) in providerSortAry" :key="key" :value="key">
              <button
                class="account_wallet_card w-100"
                type="button"
                @click="showModal(item.game_provider_id)"
              >
                <div class="account_wallet_card-container">
                  <h5 class="text-left">
                    <b>{{ getStoreGameBalance(item.game_provider_id).game_provider_name }}</b>
                  </h5>
                  <h6 class="text-left">
                    {{ $t('Bao.withdrawal_limit') }} <span>{{ $options.filters['numberFormat'](getStoreGameBalance(item.game_provider_id).withdrawal_limit) }}</span>
                  </h6>
                  <h3 class="text-right mb-0">
                    <b v-if="!isLoading">{{ $options.filters['numberFormat'](getStoreGameBalance(item.game_provider_id).amount) }}</b>
                    <i v-else class="fa fa-spinner fa-pulse fa-fw" />
                  </h3>
                </div>
              </button>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <b-modal
      id="modal_notice"
      ref="modal_notice"
      modal-class="modal_wallet modal_wallet-border"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
      footer-class="modal-footer justify-content-center border-top-0"
      header-class="modal-header justify-content-center align-items-center border-bottom-0"
      body-class="modal-body text-center"
      dialog-class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-md"
    >
      <template v-slot:modal-header>
        <h4 class="mb-0">
          <b>{{ $t('Bao.leave_game_all') }}</b>
        </h4>
        <button type="button" class="close rounded-circle m-0" @click="hideWithdrawalAllModal">
          <i class="icon-clear" />
        </button>
      </template>
      <template v-slot:modal-footer>
        <div class="wallet_transfer_btn modal_btns d-flex justify-content-center w-100">
          <button class="btn btn_transfer text-white" type="button" @click="withdrawalAll">
            {{ $t('Bao.submit') }}
          </button>
          <button class="btn btn_immediately" type="button" @click="hideWithdrawalAllModal">
            {{ $t('Bao.cancel') }}
          </button>
        </div>
      </template>
      <h6 class="mb-0 nl2br">
        {{ $t('Bao.leave_game_all_notice') }}
      </h6>
    </b-modal>
  </main>
</template>

<script>
import { gameBalance, withdrawalAll } from '@/api/game'
import { showGameWalletModal } from '@/utils/games'
import { autoToGame } from '@/api/user'
import { refreshGold, showNotice } from '@/utils/tool'

export default {
  data() {
    return {
      providerSortAry: null,
      isLoading: false,
      transferForm: {
        type: 'in',
        game_provider_id: null,
        amount: null
      },
      actionLoading: false
    }
  },
  computed: {
    autoToGameClass() {
      if (this.$store.getters.user.auto_to_game === 1) {
        return 'wallet_info_ipt d-none checked'
      } else {
        return 'wallet_info_ipt d-none'
      }
    }
  },
  created() {
    // 開啟socket
    this.$socket.init()

    this.getGameBalance()
  },
  methods: {
    getStoreGameBalance(game_provider_id) {
      return this.$store.getters.gameBalance[game_provider_id]
    },
    refreshAll() {
      // showNotice(this.$t('Bao.game_balance_sync_limit'))
      this.getGameBalance()
      this.refreshGold()
    },
    getGameBalance() {
      this.isLoading = true
      const self = this
      gameBalance().then((response) => {
        this.$store.commit('SET_GAME_BALANCE_INFO', response.data.data)

        this.providerSortAry = Object.values(this.$store.getters.gameBalance)
        this.providerSortAry.sort(function(a, b) {
          if (a.sort < b.sort) return -1
          if (a.sort > b.sort) return 1
          return 0
        })

        this.transferForm.game_provider_id = this.providerSortAry[0].game_provider_id
      }).catch(() => {
      }).finally(function() {
        self.isLoading = false
      })
    },
    updateAutoToGame() {
      // ui先改
      const memberInfo = this.$store.getters.user
      let status = memberInfo.auto_to_game
      status = 1 - status

      memberInfo.auto_to_game = status
      this.$store.commit('SET_MEMBER_INFO', memberInfo)

      autoToGame(status).then((response) => {
        // api回來再改一次
        this.$store.commit('SET_MEMBER_INFO', response.data.data)
      }).catch(() => {
      })
    },
    refreshGold() {
      refreshGold()
    },
    withdrawalAll() {
      this.hideWithdrawalAllModal()
      this.$store.commit('SET_LOADING', true)
      this.actionLoading = true

      const self = this
      withdrawalAll().then((response) => {
        showNotice(response.data.msg, function() {
          self.isLoading = true

          setTimeout(function() {
            self.isLoading = false
          }, 5000)
        })
      }).catch(() => {
      }).finally(() => {
        this.$store.commit('SET_LOADING', false)
        this.actionLoading = false
      })
    },

    showWithdrawalAllModal() {
      this.$bvModal.show('modal_notice')
    },
    hideWithdrawalAllModal() {
      this.$bvModal.hide('modal_notice')
    },
    showModal(gameProviderId) {
      showGameWalletModal(gameProviderId)
    }
  }
}
</script>
